import React, { PropTypes } from 'react';
import Page from '../../Page';

const Div = ({ value: { style, content, id } }) => (
  <Page id={id} style={style} data={content} />
);


Div.propTypes = {
  value: PropTypes.shape({
    style: PropTypes.object,
    content: PropTypes.array
  })
};

export default Div;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/Div/Div.js
 **/